export default "<div [ngClass]=\"inputClass ? inputClass : 'app-loading-spinner'\">\n  <mat-spinner [diameter]=\"diameter\"></mat-spinner>\n</div>\n";